import configureCommonStore from '@lifeomic/phc-web-toolkit/dist/redux';

const store = configureCommonStore(undefined);

export default store;
